export default "__VITE_ASSET__34c1b30e__"